// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","97":"Profile"}[chunkId] + "." + {"72":"76ef35c2","97":"701dd221"}[chunkId] + ".chunk.js";
};